import { lazy } from 'react';

import type { TabKenh } from '../channels/tabRegistry.js';

/**
 * Hai mục của module 08 trong tab "Doanh thu & chia sẻ": dải bốn ô chia %
 * nhân sự (`cot: 'dai'`, đầu tab) và "Doanh thu chi tiết" (dòng tiền của kỳ,
 * sao kê dọc).
 *
 * Order **20**: ngay sau "Doanh thu theo ngày" của module 07 (order 5) và
 * trước Network (30) rồi đội ngũ (40) — thứ tự đọc là số YouTube → số sao kê →
 * hợp đồng → phần chia (bước 3, 22/10/2026).
 */
const channelTabs: TabKenh[] = [
  {
    /*
     * Dải bốn ô của tab: gộp → thực nhận → (chia nhân sự · công ty giữ lại)
     * hoặc (lợi nhuận kênh · phần của bạn). `cot: 'dai'` ⇒ trọn bề ngang, trên
     * lưới hai cột; `order: 1` ⇒ trước cả "Doanh thu theo ngày" (order 5).
     */
    id: 'dai-chia-se',
    nhom: 'doanh-thu-chia-se',
    cot: 'dai',
    label: 'Chia % nhân sự',
    order: 1,
    permission: { module: 'revenue', level: 'view' },
    component: lazy(() => import('./components/DaiChiaSeKenh.js')),
  },
  {
    id: 'doanh-thu',
    nhom: 'doanh-thu-chia-se',
    cot: 'trai',
    label: 'Doanh thu chi tiết',
    order: 20,
    permission: { module: 'revenue', level: 'view' },
    component: lazy(() => import('./components/TabDoanhThu.js')),
  },
];

export default channelTabs;
